import {makeid,isLocalHost} from '../../core/helpers/CoreHelpers'
import jwtDecode from "jwt-decode";
import {oldToken} from '../../core/store/actions/user'
import CoreConfig from '../../core/config'

export default {
    'name': CoreConfig.name,
    'api': CoreConfig.api,
    'language': CoreConfig.language,
    'prefix': CoreConfig.prefix,
    'adminURL': CoreConfig.adminURL,
    'frontURL': CoreConfig.frontURL,
    'client': CoreConfig.client,
    'renderer': CoreConfig.renderer,
    'initialRoute':CoreConfig.initialRoute,
    destroy: CoreConfig.destroy,
    set:CoreConfig.set,
    get:CoreConfig.get,
    clearStorage:CoreConfig.clearStorage,
    setToken:CoreConfig.setToken,
    getToken:CoreConfig.getToken,
    setUser:CoreConfig.setUser,
    getUser:CoreConfig.getUser,
    getApiConfig:CoreConfig.getApiConfig,
    getId:CoreConfig.getId,
    getStoragePrefixes:CoreConfig.getStoragePrefixes,
    generateId:CoreConfig.generateId,
    getSsoLink:CoreConfig.getSsoLink,
    getSsoId:CoreConfig.getSsoId,
    setSsoId:CoreConfig.setSsoId,
};


// WEBPACK FOOTER //
// ./src/frontend/config/index.js